import React, { FC } from "react";
import { Helmet } from "react-helmet";
import SocialsList from "shared/SocialsList/SocialsList";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
// import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
// import SectionClientSay from "components/SectionClientSay/SectionClientSay";
// import BackgroundSection from "components/BackgroundSection/BackgroundSection";

export interface PageContactProps {
  className?: string;
}

const info = [
  {
    title: "🗺 ALAMAT",
    desc: "Balai Diklat Industri, Denpasar",
    href: "https://goo.gl/maps/AGeJTiiN19q85ucY9"
  },
  {
    title: "💌 EMAIL",
    desc: "halo@rentrips.id",
    href: "mailto:halo@rentrips.id"
  },
  {
    title: "☎ TELEPON",
    desc: "+62-851-6151-4605",
    href: "http://wa.me/6285161514605"
  },
];

const PageContact: FC<PageContactProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageContact overflow-hidden ${className}`}
      data-nc-id="PageContact"
    >
      <Helmet>
      <title>Kontak || Rentrips ID</title>
      </Helmet>
      <div className="mb-24 lg:mb-32">
        <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          Hubungi Kami
        </h2>
        <div className="container max-w-7xl mx-auto">
          <div className="flex-shrink-0 grid grid-cols-2 gap-12 ">
            <div className="max-w-sm space-y-8">
              {info.map((item, index) => (
                <div key={index}>
                  <h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
                    {item.title}
                  </h3>
                  <a
                    href={item.href}
                    className="block mt-2 text-neutral-500 dark:text-neutral-400" target="_blank" rel="noopener noreferrer">
                    {item.desc}
                  </a>
                </div>
              ))}
              <div>
                <h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
                  🌏 MEDIA SOSIAL
                </h3>
                <SocialsList className="mt-2" />
              </div>
            </div>
            <div>
              <form className="grid grid-cols-1 gap-6" action="#" method="post">
                <label className="block">
                  <Label>Nama Lengkap</Label>
                  <Input
                    placeholder="Masukkan Nama"
                    type="text"
                    className="mt-1"
                  />
                </label>
                <label className="block">
                  <Label>Email Anda</Label>

                  <Input
                    type="email"
                    placeholder="Masukkan Email"
                    className="mt-1"
                  />
                </label>
                <label className="block">
                  <Label>Pesan</Label>

                  <Textarea className="mt-1" rows={6} placeholder="Masukkan Pesan" />
                </label>
                <div>
                  <ButtonPrimary type="submit">Kirim Pesan</ButtonPrimary>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* OTHER SECTIONS */}
      {/* <div className="container">
        <div className="relative py-16">
          <BackgroundSection />
          <SectionClientSay />
        </div>
        <SectionSubscribe2 className="py-24 lg:py-32" />
      </div> */}
    </div>
  );
};

export default PageContact;
